import { createStore, withProps, select } from '@ngneat/elf';
import { ExtraStructure } from '../model';
import { filter } from 'rxjs/operators';

export interface ExtraState extends ExtraStructure {
  loading: boolean;
}

const store = createStore(
  { name: 'extra' },
  withProps<ExtraState>({ hotelExtras: [], roomExtras: {}, loading: false })
);

const extraLoaded$ = store.pipe(
  select((state) => state),
  filter((state) => state && !state.loading)
);

const extraIsLoading$ = store.pipe(select((state) => state.loading));

const setLoading = (loading: boolean) =>
  store.update((state) => ({ ...state, loading }));

const updateExtra = (extra: ExtraStructure) =>
  store.update((state) => ({ ...state, ...extra }));

export const ExtraRepository = {
  store,
  extraIsLoading$,
  extraLoaded$,
  updateExtra,
  setLoading,
};
